import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "UploadingProgressMixin" })
export default class UploadingProgressMixin extends Vue {
  @Prop({ type: Number, default: 0 })
  public readonly progress!: number;

  public get loaded() {
    return this.progress === 100;
  }

  public get loading() {
    return this.progress > 0 && this.progress < 100;
  }
}
